import { AuthCheckAdmin } from '../../../../Utils/AuthCheck/AdminCheck.auth';
import React from 'react';
import { FormContainer } from '../../../CreateRoutes/CreateForm.styles';
import { useParams } from 'react-router-dom';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../../../Components/PageHelmet/HelmetHelper.component';
import { useQuery } from '@tanstack/react-query';
import { httpGetPurchaseHistory } from '../../../../Hooks/user/user.get.hooks';
import EachPurchaseEntity from '../../../../CompanyRoutes/PurchaseHistory/EachPurchase.component';

const PurchaseHistoryOfUserAdmin = () => {
  const { id: userId } = useParams();
  const {
    data: purchaseHistory,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['purchaseHistory'],
    queryFn: () => httpGetPurchaseHistory(userId),
    enabled: !!userId,
    retry: 5,
  });
  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error loading purchase history</p>;
  console.log('Purchase History:', purchaseHistory);
  return (
    <AuthCheckAdmin>
      <HelmetHelper title="Edit User" description="Form for updating a user" />
      <FormContainer>
        <BreadCrumbs
          one="Admin Dashboard - User"
          oneLink={`/admin/user-home/${userId}`}
          two="Purchase History"
        />
        <h2>Purchase History</h2>
        {purchaseHistory?.length > 0 ? (
          purchaseHistory?.map((purchase, i) => (
            <EachPurchaseEntity purchase={purchase} key={i} />
          ))
        ) : (
          <p>No purchase history available.</p>
        )}
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default PurchaseHistoryOfUserAdmin;
